import React from "react";
import HomePage from "../pages/Home";
import GitHub from "../pages/GitHub";
import AzureMonitoring from "../pages/AzureMonitoring";
import DomainsMonitoring from "../pages/DomainsMonitoring";
import MaintenancePage from "../pages/Maintenance";
import ConfigStore from "../pages/ConfigStore";
import ArgoCDPage from "../pages/ArgoCD";

interface MainContentProps {
  activePage: string;
  onNavigate: (page: string) => void;
}

const MainContent: React.FC<MainContentProps> = ({ activePage, onNavigate }) => {
  // Render the appropriate page based on activePage state
  const renderPage = () => {
    switch (activePage) {
      case "Home":
        return <HomePage onNavigate={onNavigate} />;
      case "GitHub":
        return <GitHub />;
      // case "AzureMonitoring":
      //   return <AzureMonitoring />;
      // case "DomainsMonitoring":
      //   return <DomainsMonitoring onNavigate={onNavigate} />;
      // case "Maintenance":
      //   return <MaintenancePage onNavigate={onNavigate} />;
      case "ConfigStore":
        return <ConfigStore />;
      case "ArgoCD":
        return <ArgoCDPage />;
      default:
        return <div className="p-8 text-center">Page not found</div>;
    }
  };

  return (
    <div className="container mx-auto">
      {renderPage()}
    </div>
  );
};

export default MainContent;
